if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();

                this.elements = {
                    viewer: this.querySelector('[id^="Gallery-Viewer"]'), // 媒体轮播对象
                    thumbnails: this.querySelector('[id^="Gallery-Thumbnail-Slider"]') // 缩略图轮播对象
                };

                this.ifMediaStack = this.hasAttribute('data-media-stack');

                if (!this.elements.thumbnails) return;
                this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
                    thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
                });

                this.addEventListener('sliderChanged', this.onSlideChanged.bind(this));
            }

            /**
             * 媒体切换事件
             * @param event
             */
            onSlideChanged(event) {
                if(!event || !event.detail) return;

                const mediaId = event.detail.currentElement.dataset.mediaId;

                // 滚动缩略图到当前媒体
                const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                if(!thumbnail) return;

                if (!thumbnail.querySelector('button').hasAttribute('aria-current')) {
                    this.setActiveThumbnail(thumbnail);
                }
                if (this.elements.thumbnails.initSliderStatus) this.elements.thumbnails.slideByElement(thumbnail); // 滚动到合适的位置
            }

            /**
             * 点击缩略图处理
             */
            onThumbnailClick(event) {
                const thumbnail = event.currentTarget;
                this.setActiveThumbnail(thumbnail);

                this.changeMedia(thumbnail.getAttribute('data-target'));
            }

            /**
             * 更新相册，如果需要隐藏其它变体图片，需要重新安装轮播组件
             * @param currentVariantMediaId 当前变体的 Featured Media Id
             */
            updateGallery(currentVariantMediaId) {
                this.elements.viewer.querySelector('.is-current-variant-media')?.classList.remove('is-current-variant-media');
                this.elements.viewer.querySelector(`[data-media-id="${currentVariantMediaId}"]`)?.classList.add('is-current-variant-media');
                if (this.elements.thumbnails) {
                    this.elements.thumbnails.querySelector('.is-current-variant-thumbnail')?.classList.remove('is-current-variant-thumbnail');
                    this.elements.thumbnails.querySelector(`[data-target="${currentVariantMediaId}"]`)?.classList.add('is-current-variant-thumbnail');
                }

                // 如果启用了隐藏其它变体媒体，需要重新初始化轮播
                if (this.hasAttribute('data-hide-variants') && !this.ifMediaStack) {
                    this.elements.viewer.reInstall();
                    if (this.elements.thumbnails) this.elements.thumbnails.reInstall();
                }

                this.changeMedia(currentVariantMediaId);
            }

            /**
             * 设置活跃媒体
             * @param mediaId
             */
            changeMedia(mediaId) {
                const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

                if (this.ifMediaStack) {
                    // 如果是 Stack 布局，需要将当前变体 Featured Media 放置最前面
                    activeMedia.parentElement.prepend(activeMedia);
                } else {
                    // 轮播模式，切换当前轮播
                    if (this.elements.viewer.initSliderStatus) this.elements.viewer.slideByElement(activeMedia);
                }
            }

            /**
             * 设置活跃缩略图
             * @param thumbnail
             */
            setActiveThumbnail(thumbnail) {
                if (!this.elements.thumbnails || !thumbnail) return;

                this.elements.thumbnails
                    .querySelectorAll('button')
                    .forEach((element) => element.removeAttribute('aria-current'));

                thumbnail.querySelector('button').setAttribute('aria-current', true);
            }
        }
    );
}
